import { render, staticRenderFns } from "./DataSetField.vue?vue&type=template&id=dcaf71a2&scoped=true"
import script from "./DataSetField.vue?vue&type=script&lang=js"
export * from "./DataSetField.vue?vue&type=script&lang=js"
import style0 from "./DataSetField.vue?vue&type=style&index=0&id=dcaf71a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaf71a2",
  null
  
)

export default component.exports